import React from 'react';
import styles from './styles.m.sass';
import { observer } from 'mobx-react';
export default observer(function TypingIndicator(_ref) {
  var peopleCurrentlyTyping = _ref.peopleCurrentlyTyping;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.typing
  }, peopleCurrentlyTyping.length > 4 ? 'Several people are typing.' : /*#__PURE__*/React.createElement(SpecificTypingIndicator, {
    peopleCurrentlyTyping: peopleCurrentlyTyping
  })));
});
function SpecificTypingIndicator(_ref2) {
  var peopleCurrentlyTyping = _ref2.peopleCurrentlyTyping;
  if (peopleCurrentlyTyping.length === 0) {
    return null;
  }
  var last = peopleCurrentlyTyping.slice(-1)[0];
  var rest = peopleCurrentlyTyping.slice(0, -1);
  return /*#__PURE__*/React.createElement(React.Fragment, null, rest.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, rest.map(function (name, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, name), i < rest.length - 1 && /*#__PURE__*/React.createElement(React.Fragment, null, ", "));
  }), ' and '), last && /*#__PURE__*/React.createElement("span", null, last), " ", rest.length > 0 ? 'are' : 'is', " typing");
}
//# sourceMappingURL=index.js.map
